export const getCookieByName = cookieName => {
    if (typeof document === 'undefined') {
        return;
    }

    const allCookies = document.cookie.split('; ');
    const cookies = allCookies.reduce((cookieObj, newCookie) => {
        var index = newCookie.indexOf('=');
        cookieObj[newCookie.substring(0, index)] = newCookie.substring(
            index + 1
        );

        return cookieObj;
    }, {});

    return cookies[cookieName];
};
